module.exports = __webpack_public_path__ + "static/media/flag-check.7ad1e5be.svg";